import ApiClient from '../ApiClient';

class SurgeChannel extends ApiClient {
  constructor() {
    super('channels/surge_channel', { accountScoped: true });
  }
}

export default new SurgeChannel();
